import { render, staticRenderFns } from "./FormartPay.vue?vue&type=template&id=58d9ee4d&scoped=true&"
import script from "./FormartPay.vue?vue&type=script&lang=js&"
export * from "./FormartPay.vue?vue&type=script&lang=js&"
import style0 from "./FormartPay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormartPay.vue?vue&type=style&index=1&id=58d9ee4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d9ee4d",
  null
  
)

export default component.exports